import React from 'react';

import { Box } from '@occc-app/design-system';
import { Tab, Tabs as MuiTabs, TabsProps, tabClasses, tabsClasses } from '@occc/ui-design-system';

type TabContentProps = {
  id: string | number;
  value: string | number;
  children: React.ReactNode;
};

export const TabContent: React.FC<TabContentProps> = ({ value, id, children }) => {
  return <Box sx={{ display: value !== id ? 'none' : undefined }}>{children}</Box>;
};

export const Tabs = (props: TabsProps) => {
  return (
    <MuiTabs
      {...props}
      sx={(theme) => ({
        mx: 2,
        [`.${tabClasses.root}`]: {
          color: theme.palette.common.white,
          opacity: 0.7,
          [`&.${tabClasses.selected}`]: {
            color: theme.palette.common.white,
            opacity: 1,
          },
        },
        [`.${tabClasses.disabled}`]: {
          color: theme.palette.common.white,
          opacity: 0.4,
        },
        [`.${tabsClasses.indicator}`]: {
          background: theme.palette.common.white,
        },
      })}
    ></MuiTabs>
  );
};

export { Tab };
